import Delete2 from "@Components/Icons/Delete2";
import Update from "@Components/Icons/Update";
import { Box, Paper, Table as MuiTable, TableBody, TableCell, TableContainer, TableHead, TableRow, } from "@mui/material";
import dayjs from "dayjs";
import React from "react";
import styles from "./index.module.scss";
const TableCellHeaderStyled = {
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "125%",
    padding: "8px 24px",
    borderLeft: "1px solid #CCD4DC",
    "&:last-child": {
        borderRight: "none",
    },
};
const TableCellRowStyled = {
    fontSize: "12px",
    lineHeight: "125%",
    padding: "8px 24px",
    borderLeft: "1px solid #CCD4DC",
    "&:last-child": {
        borderRight: "none",
    },
};
const TruncateTextStyle = {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "500px",
};
export const displayDate = (date, showTime = false) => {
    if (!date) {
        return;
    }
    let template = "DD/MM/YYYY";
    if (showTime) {
        template = template + ", HH:mm";
    }
    return date.utc(true).format(template);
};
export default class Table extends React.Component {
    render() {
        return (React.createElement(TableContainer, { component: Paper },
            React.createElement(MuiTable, null,
                React.createElement(TableHead, null,
                    React.createElement(TableRow, { sx: {
                            backgroundColor: "#f5f5f5",
                            borderBottom: "1px solid #CCD4DC",
                        } },
                        React.createElement(TableCell, { sx: {
                                ...TableCellHeaderStyled,
                                width: 80,
                            } }, "Order"),
                        React.createElement(TableCell, { sx: TableCellHeaderStyled }, "Name"),
                        React.createElement(TableCell, { sx: {
                                ...TableCellHeaderStyled,
                                minWidth: 150,
                            } }, "Created Date"),
                        React.createElement(TableCell, { sx: {
                                ...TableCellHeaderStyled,
                                minWidth: 150,
                            } }, "Updated Date"),
                        React.createElement(TableCell, { sx: TableCellHeaderStyled }, "Action"))),
                React.createElement(TableBody, null, this.props.rows.map((plan, index) => (React.createElement(TableRow, { key: plan.id, sx: {
                        backgroundColor: index % 2 === 0 ? "#ffffff" : "#F5F5F5",
                    } },
                    React.createElement(TableCell, { sx: TableCellRowStyled }, index + 1),
                    React.createElement(TableCell, { sx: TableCellRowStyled },
                        React.createElement(Box, { sx: TruncateTextStyle, title: plan.name }, plan.name)),
                    React.createElement(TableCell, { sx: TableCellRowStyled }, displayDate(dayjs(plan.createdAt), true)),
                    React.createElement(TableCell, { sx: TableCellRowStyled }, displayDate(dayjs(plan.updatedAt), true)),
                    React.createElement(TableCell, { sx: TableCellRowStyled },
                        React.createElement(Box, { sx: {
                                display: "flex",
                                gap: "12px",
                                width: "100%",
                            } },
                            React.createElement(Update, { onClick: () => this.props.onEdit(plan), className: styles.editButton }),
                            React.createElement(Delete2, { onClick: () => this.props.onDelete(plan), className: styles.deleteButton }))))))))));
    }
}
